export default "__VITE_ASSET___NKqjAw6__"